import React, { useEffect, useState } from "react";
import { templateInvoiceCustomerData } from "../../data/order/invoice/invoiceOrderData";
import { OrderContent } from "../order/OrderList";
import useInvoiceApi from "../../hooks/useInvoiceApi";
import { useSelector } from "react-redux";
import InvoiceCustomerMenu from "../order/menu/InvoiceCustomerMenu";
import { URLdecode } from "../../utils/url";
import useGeneralActions from "../../hooks/useGeneralActions";

function InvoiceCustomerList({ search }) {
  const params = URLdecode();
  const { resetPagination } = useGeneralActions();
  const { getCustomers } = useInvoiceApi();
  const { customers } = useSelector((state) => state.invoice);
  const [loading, setLoading] = useState(false);
  const getItems = (raw) => {
    const data = raw
      ? customers
      : customers.map((item) => templateInvoiceCustomerData(item));
    return data;
  };

  const [orders, ogData] = [getItems(), getItems(true)];

  const loadData = async () => {
    await getCustomers({
      setLoading,
      search,
    });
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    loadData();
  }, [search, params?.filter, params?.page, params?.limit]);

  useEffect(() => {
    resetPagination();
  }, [search]);

  if (!loading && !orders?.length) return <></>;

  return (
    <div className="flex flex-1 mt-6 bg-[#F0F6FC] rounded-md p-1">
      <div className="flex flex-1 flex-col gap-2">
        {loading ? (
          <div className="w-full flex flex-col items-center justify-center">
            <div className="primaryLoader"></div>
          </div>
        ) : (
          <></>
        )}
        {orders?.map((order, index) => (
          <Order key={index} order={order} og={ogData?.at(index)} />
        ))}
      </div>
    </div>
  );
}

export default InvoiceCustomerList;

const Order = ({ order, og }) => {
  const bookingData = og?.flightBooking?.at(0);
  const [open, setOpen] = useState(false);

  console.log({ order, og });

  return (
    <div className="w-full flex  justify-between bg-white p-4 gap-3 rounded-md ">
      <div className="flex flex-col md:flex-row justify-between flex-1 overflow-clip max-w-[calc(100%-62px)]">
        {order?.map(({ elements, cover, width }, index) => (
          <div
            className={`w-full ${width || "flex-1"} ${
              !open && index !== 0 ? "hidden md:flex" : "flex"
            } flex-col ${
              open && "border-b pb-3"
            } mb-2 px-2 md:border-b-0 md:pb-0`}
            key={index}
          >
            <div className={`hidden sm:flex flex-col `}>
              {elements?.map((element, idx) => (
                <OrderContent element={element} key={idx} booking={og} />
              ))}
            </div>
            <div className="flex flex-col sm:hidden">
              {!cover
                ? elements?.map((element, idx) => (
                    <OrderContent element={element} key={idx} booking={og} />
                  ))
                : cover}
            </div>
          </div>
        ))}
      </div>

      <div
        className={`${
          bookingData?.status || og?.status ? "flex" : "flex"
        } flex-col gap-4 items-center min-w-[50px]`}
      >
        <InvoiceCustomerMenu og={og} order={order} />
        <div
          className="flex md:hidden sticky top-10"
          onClick={() => setOpen(!open)}
        >
          {open ? (
            <img
              src="/IconChevronUp.svg"
              alt=""
              className="w-5 object-contain"
            />
          ) : (
            <img
              src="/IconChevronDown.svg"
              alt=""
              className="w-5 object-contain"
            />
          )}
        </div>
      </div>
    </div>
  );
};
